module.exports = __webpack_public_path__ + "img/modulo-2.2fd31a3c.svg";